module.exports = " <div id=header class=app-content-header role=main ui-view=header@> </div> <md-sidenav id=aside class=\"app-aside md-sidenav-left\" ng-class=\"{'folded': folded}\" ui-view=aside@ md-component-id=aside> </md-sidenav> <div id=content class=app-content role=main ui-view=content@> </div> <div id=chatbox role=main ui-view=chatbox@ ng-show=showChat> </div> <div id=reflections role=main ui-view=reflections@ ng-show=showReflections> </div> <div id=comments role=main ui-view=comments@ ng-show=showComments> </div> <div id=footer ui-view=footer@> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout.html
// module id = 168
// module chunks = 0